import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
    addCustomTemplate,
    deleteCustomTemplate,
    deleteTicket,
    editCustomTemplate,
    getCurrentChatLimit,
    getCustomTemplates,
    getDailyChatLimit,
    getOperatorCurrentStatusHistory,
    getOperatorHotkeysConfig,
    getOperatorTickets,
    updateTicketStatus
} from '../../../../services/company/api';
import Translate, {t} from '../../../../components/Translate';
import './MyHistory.css';
import ConfirmationDialog from './ConfirmationDialog';
import config from "../../../../config";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../services/chat/action";
import {confirmActionRequested} from "../../../../services/confirmAction/action";
import {connect} from "react-redux";
import Modal from "react-modal";
import SelectedConversationHistory, {generalStyles} from "../management/history/ConversationHistory";
import LoadingComponent from "../../../../assets/LoadingComponent";
import StatisticsConvModal from "../../../../components/StatisticsConvModal";
import OperatorStatistics from "./components/OperatorStatistics";
import Tickets from "./components/Tickets";
import CustomTemplates from "./components/CustomTemplates";
import Hotkeys from "./components/Hotkeys";
import {getTodayDate, getTomorrowDate, myDarkBlue, tabButtonStyles} from "../../../../utils/General";

const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'space-between',
        maxWidth: '95%',
        margin: '20px auto'
    },
    dateFilterContainer: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
        marginBottom: '20px',
        alignItems: 'center',
    },
    card: {
        cursor: 'pointer',
        borderRadius: '20px',
        backgroundColor: 'white',
        padding: '40px',
        flex: '1 1 calc(33.333% - 20px)',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    },
    icon: {
        fontSize: '3rem',
        marginBottom: '10px',
        color: myDarkBlue
    },
    searchInput: {
        width: '100%',
        marginBottom: '20px',
        padding: '10px',
        borderRadius: '20px',
        boxSizing: 'border-box',
        background: 'white',
        border: '0'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        borderRadius: '20px',
        overflow: 'visible',
    },
    th: {
        // border: `1px solid ${myDarkBlue}`,
        padding: '12px 15px',
        backgroundColor: myDarkBlue,
        color: 'white',
        textAlign: 'left',
        cursor: 'pointer'
    },
    td: {
        border: `0`,
        padding: '12px 15px',
        textAlign: 'left',
        color: myDarkBlue,
        // background: mySilver
    },
    fullWidthContainer: {
        flex: '1 1 100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px'
    },
    fullWidthCard: {
        flex: '1 1 100%',
        borderRadius: '20px',
        backgroundColor: 'white',
        padding: '40px',
        boxSizing: 'border-box',
        position: 'relative',
        maxHeight: '800px',
        overflow: 'auto'
    },
    parentTableDiv: {
        maxHeight: '295px',
        overflow: 'auto'
    },
    rowTicket: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    ticketColumn: {
        flex: '1 1 calc(33.333% - 20px)',
        margin: '10px',
        padding: '20px',
        borderRadius: '10px',
        position: 'relative',
        textAlign: 'center',
        minHeight: '400px'
    },
    ticketCard: {
        margin: '10px',
        padding: '20px',
        borderRadius: '10px',
        position: 'relative',
        boxShadow: 'rgba(-16, 33, 116, 0.2) 1px 1px 4px 3px',
        textAlign: 'center',
        cursor: 'grab',
    },
    ticketTitle: {
        marginBottom: '10px',
        color: 'rgb(61, 86, 143)'
    },
    ticketCategory: {
        marginBottom: '10px'
    },
    btnTicket: {
        backgroundColor: 'rgb(4, 62, 92)',
        border: 'none',
        color: '#fff',
        padding: '8px 15px',
        borderRadius: '15px',
        cursor: 'pointer'
    },
    pMarginBottom: {
        marginBottom: '15px',
    },
    closeBtn: {
        backgroundColor: '#fff',
        border: 'none',
        color: 'rgb(4, 62, 92)',
        padding: '15px',
        borderRadius: '15px',
        cursor: 'pointer',
    },
};

function MySpace({
                     user,
                     company,
                     selectConversation,
                     loadOlderMessages,
                     clearSelectedConversationFromStore,
                     conversation,
                     confirmAction,
                     addNotification
                 }) {

    const {tariff} = company;
    const {features} = tariff;

    const [tickets, setTickets] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupContent, setPopupContent] = useState({});
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [ticketToDelete, setTicketToDelete] = useState(null);
    const [columnToDeleteFrom, setColumnToDeleteFrom] = useState(null);
    const [ticketColumns, setTicketColumns] = useState({
        'toDo': [],
        'inProgress': [],
        'done': []
    });
    const [fetched, setFetched] = useState(false);

    const [customTemplates, setCustomTemplates] = useState([]);
    const [hotkeys, setHotkeys] = useState([]);

    const [currentStatusHistory, setCurrentStatusHistory] = useState([]);

    const [dailyChatsLimit, setDailyChatsLimit] = useState('');
    const [currentChatsLimit, setCurrentChatsLimit] = useState('');
    const [avrgConvTime, setAvrgConvTime] = useState('');
    const [avrgAnswerSpeed, setAvrgAnswerSpeed] = useState('');
    const [avrgFirstAnswerSpeed, setAvrgFirstAnswerSpeed] = useState('');

    const [activeTab, setActiveTab] = useState('statistics');

    const [startDateForCurrentStatus, setStartDateForCurrentStatus] = useState(getTodayDate());
    const [endDateForCurrentStatus, setEndDateForCurrentStatus] = useState(getTomorrowDate());

    useEffect(() => {
        getOperatorCurrentStatusHistory(startDateForCurrentStatus, endDateForCurrentStatus).then(data => {
            setCurrentStatusHistory(data);
        })
    }, [startDateForCurrentStatus, endDateForCurrentStatus])

    useEffect(() => {
        const fetchChatCount = async () => {
            try {
                const promises = [];
                const resultsMapping = {};

                if (features.includes(config.features.MY_HISTORY)) {
                    resultsMapping[config.features.MY_HISTORY] = promises.length;
                    promises.push(
                        Promise.all([
                            getDailyChatLimit(),
                            getCurrentChatLimit(),
                            getOperatorCurrentStatusHistory(startDateForCurrentStatus, endDateForCurrentStatus)
                        ])
                    );
                }

                if (features.includes(config.features.TEMPLATES)) {
                    resultsMapping[config.features.TEMPLATES] = promises.length;
                    promises.push(getCustomTemplates());
                }

                if (features.includes(config.features.TICKETS)) {
                    resultsMapping[config.features.TICKETS] = promises.length;
                    promises.push(getOperatorTickets());
                }

                if (features.includes(config.features.HOTKEYS)) {
                    resultsMapping[config.features.HOTKEYS] = promises.length;
                    promises.push(getOperatorHotkeysConfig());
                }


                const results = await Promise.all(promises);

                if (config.features.MY_HISTORY in resultsMapping) {
                    const [
                        dailyChatsLimit,
                        currentChatsLimit,
                        currentStatusHistory
                    ] = results[resultsMapping[config.features.MY_HISTORY]];

                    setDailyChatsLimit(dailyChatsLimit);
                    setCurrentChatsLimit(currentChatsLimit);
                    setAvrgConvTime(avrgConvTime);
                    setAvrgAnswerSpeed(avrgAnswerSpeed);
                    setAvrgFirstAnswerSpeed(avrgFirstAnswerSpeed);
                    setCurrentStatusHistory(currentStatusHistory);
                }

                if (config.features.TICKETS in resultsMapping) {
                    const tickets = results[resultsMapping[config.features.TICKETS]];
                    setTickets(tickets);
                    setTicketColumns({
                        toDo: tickets.filter(ticket => ticket.ticketStatus === "TODO"),
                        inProgress: tickets.filter(ticket => ticket.ticketStatus === "IN_PROGRESS"),
                        done: tickets.filter(ticket => ticket.ticketStatus === "DONE"),
                    });
                }

                if (config.features.TEMPLATES in resultsMapping) {
                    const customTemplates = results[resultsMapping[config.features.TEMPLATES]];
                    setCustomTemplates(customTemplates);
                }

                if (config.features.HOTKEYS in resultsMapping) {
                    const hotkeysData = results[resultsMapping[config.features.HOTKEYS]];
                    setHotkeys(hotkeysData);
                }

                setFetched(true);
            } catch (error) {
                setFetched(false);
                console.error("Error fetching chat counts:", error);
            }
        };

        fetchChatCount();
    }, [user.id, features]);


    const onDragStart = (event, ticketId, column) => {
        event.dataTransfer.setData('ticketId', ticketId);
        event.dataTransfer.setData('fromColumn', column);

    };

    const onDrop = (event, column) => {
        const ticketId = event.dataTransfer.getData('ticketId');
        const fromColumn = event.dataTransfer.getData('fromColumn');

        if (fromColumn !== column) {
            setTicketColumns((prev) => {
                const fromTickets = prev[fromColumn].filter((ticket) => ticket.id !== parseInt(ticketId));
                const ticketToMove = prev[fromColumn].find((ticket) => ticket.id === parseInt(ticketId));
                const toTickets = [...prev[column], ticketToMove];
                return {
                    ...prev,
                    [fromColumn]: fromTickets,
                    [column]: toTickets
                };
            });
        }

        let columnName;
        if (column === 'toDo') {
            columnName = "TODO"
        } else if (column === "inProgress") {
            columnName = "IN_PROGRESS"
        } else if (column === "done") {
            columnName = "DONE"
        }
        updateTicketStatus(ticketId, columnName)
    };

    const allowDrop = (event) => {
        event.preventDefault();
    };

    const openPopup = (ticket) => {
        setPopupContent(ticket);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupContent({});
    };

    const handleDeleteTicket = (ticketId, column) => {
        setTicketToDelete(ticketId);
        setColumnToDeleteFrom(column);
        setShowConfirmationDialog(true);
    };

    const confirmDelete = () => {
        setTicketColumns((prev) => {
            const updatedColumn = prev[columnToDeleteFrom].filter((ticket) => ticket.id !== ticketToDelete);
            return {
                ...prev,
                [columnToDeleteFrom]: updatedColumn
            };
        });
        setShowConfirmationDialog(false);
        deleteTicket(ticketToDelete)
    };

    const cancelDelete = () => {
        setShowConfirmationDialog(false);
        setTicketToDelete(null);
        setColumnToDeleteFrom(null);
    };

    const showConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
            isOperatorConversation: true,
            operatorConversationId: conversationDetails.id
        });
    };

    const showFullConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
        });
    };

    const openTrModal = (key, filters = {}) => {
        confirmAction({
                content: (
                    <StatisticsConvModal
                        user={user}
                        confirmAction={confirmAction}
                        company={company}
                        showConversationHistory={showConversationHistory}
                        showFullConversationHistory={showFullConversationHistory}
                        header={key}
                        filters={{
                            ...filters,
                            operatorId: user.postgresId,
                            operator: user.firstName + ' ' + user.lastName
                        }}
                    />
                )
            }
        );
    };
    const updatePopupContent = (content) => {
        const updatedColumns = Object.keys(ticketColumns).reduce((acc, columnKey) => {
            const updatedColumn = ticketColumns[columnKey].map(ticket =>
                ticket.id === content.id ? {...ticket, ...content} : ticket
            );
            return {...acc, [columnKey]: updatedColumn};
        }, {});
        setTicketColumns(updatedColumns);
    }

    const addCustomTemplateF = (text) => {
        addCustomTemplate(text).then(res => {
            setCustomTemplates(prevTemplates => [
                ...prevTemplates,
                res
            ]);
        })
    }

    const editCustomTemplateF = (id, text) => {
        editCustomTemplate(id, text)
    }

    const deleteCustomTemplateF = (customTemplateId) => {
        deleteCustomTemplate(customTemplateId);
        setCustomTemplates(prevTemplates =>
            prevTemplates.filter(template => template.id !== customTemplateId)
        );
    }

    if (!fetched) {
        return <LoadingComponent/>;
    }

    return (
        <div>
            <div style={tabButtonStyles.tabButtons}>
                {features.includes(config.features.MY_HISTORY) && (
                    <button
                        className={`tab-button ${activeTab === 'statistics' ? 'active' : ''}`}
                        onClick={() => setActiveTab('statistics')}
                    >
                        <Translate text="statistics"/>
                    </button>
                )}

                {features.includes(config.features.TEMPLATES) && (
                    <button
                        className={`tab-button ${activeTab === 'templates' ? 'active' : ''}`}
                        onClick={() => setActiveTab('templates')}
                    >
                        <Translate text="templates"/>
                    </button>
                )}

                {features.includes(config.features.TICKETS) && (
                    <button
                        className={`tab-button ${activeTab === 'tickets' ? 'active' : ''}`}
                        onClick={() => setActiveTab('tickets')}
                    >
                        <Translate text="tickets"/>
                    </button>
                )}

                {features.includes(config.features.HOTKEYS) && (
                    <button
                        className={`tab-button ${activeTab === 'hotkeys' ? 'active' : ''}`}
                        onClick={() => setActiveTab('hotkeys')}
                    >
                        <Translate text="hotkeys"/>
                    </button>
                )}
            </div>

            <div style={styles.container}>
                {features.includes(config.features.MY_HISTORY) && activeTab === 'statistics' && company && user && (
                    <OperatorStatistics
                        company={company}
                        user={user}
                        currentStatusStartDate={startDateForCurrentStatus}
                        currentStatusEndDate={endDateForCurrentStatus}
                        setCurrentStatusStartDate={setStartDateForCurrentStatus}
                        setCurrentStatusEndDate={setEndDateForCurrentStatus}
                        dailyChatsLimit={dailyChatsLimit} currentChatsLimit={currentChatsLimit}
                        currentStatusHistory={currentStatusHistory}
                        openTrModal={openTrModal}
                    />
                )}

                {features.includes(config.features.TEMPLATES) && activeTab === 'templates' && (
                    <CustomTemplates
                        styles={styles}
                        user={user}
                        customTemplates={customTemplates}
                        addCustomTemplate={addCustomTemplateF}
                        deleteCustomTemplate={deleteCustomTemplateF}
                        editCustomTemplate={editCustomTemplateF}
                        setCustomTemplates={setCustomTemplates}
                        addNotification={addNotification}
                    />
                )}


                {features.includes(config.features.TICKETS) && activeTab === 'tickets' && (
                    <Tickets user={user} company={company} styles={styles} allowDrop={allowDrop} onDrop={onDrop}
                             ticketColumns={ticketColumns} onDragStart={onDragStart} openPopup={openPopup}
                             handleDeleteTicket={handleDeleteTicket} updatePopupContent={updatePopupContent}
                             showConversationHistory={showConversationHistory} isPopupOpen={isPopupOpen}
                             closePopup={closePopup} popupContent={popupContent} addNotification={addNotification}/>
                )}

                {features.includes(config.features.HOTKEYS) && activeTab === 'hotkeys' && (
                    <Hotkeys
                        styles={styles}
                        user={user}
                        hotkeys={hotkeys}
                        setHotkeys={setHotkeys}
                        addNotification={addNotification}
                    />
                )}


                <ConfirmationDialog
                    isOpen={showConfirmationDialog}
                    onClose={cancelDelete}
                    onConfirm={confirmDelete}
                    message={t({text: "deleteTicketFinalText", user})}
                />
                <Modal
                    closeTimeoutMS={config.closeTimeoutMS}
                    style={generalStyles.modalStyles}
                    isOpen={!!conversation.id}
                    onRequestClose={clearSelectedConversationFromStore}
                >
                    <SelectedConversationHistory
                        company={company}
                        conversation={conversation}
                        user={user}
                        loadOlderMessages={loadOlderMessages}
                        closeWindow={clearSelectedConversationFromStore}
                    />
                </Modal>
            </div>

        </div>
    );
}

MySpace.propTypes = {
    match: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(MySpace);




// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/MySpace.jsx